const documentContainer = document.querySelector( 'html' );
const browser = navigator.appName;
const browserVersion = navigator.appVersion;

if ( browser === 'Microsoft Internet Explorer' ) {
    if ( !documentContainer.classList.contains( 'is-ie' ) ) {
        documentContainer.classList.add( 'is-ie' );
    }
}